var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"daily-view"},[_c('header-vue'),_c('transition',{attrs:{"name":"fade"}},[_c('div',{key:_vm.selectedProviderID +
          '.' +
          _vm.selectedYear +
          '.' +
          _vm.selectedMonth +
          '.' +
          _vm.selectedDayOfMonth,attrs:{"id":"daily-section-container"},on:{"touchstart":_vm.touchStarted,"mousedown":_vm.touchStartedMouse,"touchend":_vm.touchEnded,"mouseup":_vm.touchEndedMouse}},[_c('section-vue'),_c('footer-vue')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }